import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Emit } from 'vue-property-decorator';
import { _CLASSES_STORE } from '@/classes/values/classes.values';

@Component({
  name: 'ed-subject-component-item',
})
export default class EdSubjectComponentItem extends Vue {

  /* Props */
  @Prop() readonly name: string;
  @Prop() readonly id: number;
  @Prop() readonly disabled: boolean;

  @Emit('editItem')
  editItem() {
    return;
  }

  @Emit('deleteItem')
  deleteItem() {
    return;
  }

}
